export default "__VITE_ASSET__Cm6j1HpE__"